import {DatePipe} from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {MAT_RIPPLE_GLOBAL_OPTIONS} from '@angular/material/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LayoutModule} from 'src/app/layout/layout.module';
import {AppInitService} from 'src/app/services/util/app-init.service';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {TranslocoRootModule} from './transloco/transloco-root.module';
import {MAT_CHIPS_DEFAULT_OPTIONS} from '@angular/material/chips';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {ToastrModule} from 'ngx-toastr';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {RxStompService} from '@stomp/ng2-stompjs';
import {ToastrTemplatesModule} from './components/toastr-templates/toastr-templates.module';
import {MatSelectModule} from '@angular/material/select';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { AutomaticLogoutPopupModule } from './components/automatic-logout-popup/automatic-logout-popup.module';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { MonacoEditorModule } from '@vality/ng-monaco-editor';

export function appInit(appInitService: AppInitService): () => Promise<any> {
  return (): Promise<any> => appInitService.init().toPromise();
}

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        TranslocoRootModule,
        LayoutModule,
        ToastrModule.forRoot(),
        MatDatepickerModule,
        MatMomentDateModule,
        ToastrTemplatesModule,
        MatSelectModule,
        SatPopoverModule,
        AutomaticLogoutPopupModule,
        MonacoEditorModule.forRoot({
        baseUrl: `${window.location.origin}/assets/monaco-editor/vs`,
        defaultOptions: { scrollBeyondLastLine: false }
        }),
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        })], providers: [
        DatePipe,
        {
            provide: APP_INITIALIZER,
            useFactory: appInit,
            deps: [AppInitService],
            multi: true
        },
        {
            provide: MAT_RIPPLE_GLOBAL_OPTIONS,
            useValue: {
                disabled: true,
            }
        },
        {
            provide: MAT_CHIPS_DEFAULT_OPTIONS,
            useValue: {
                separatorKeyCodes: [ENTER, COMMA]
            }
        },
        {
            provide: RxStompService,
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}
